import {Base} from "@/api/Base"

export class CurrencyAdd extends Base {
    path = "currency/add"
}